import { Link } from 'react-router-dom';
import { services } from '../../../mocks/studios';

export default function ServicesGrid() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-amber-600 text-xs font-bold uppercase tracking-widest mb-3 block">
            What We Offer
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-stone-900 mb-5">
            Studio Rental Options
          </h2>
          <p className="text-stone-500 text-lg max-w-2xl mx-auto leading-relaxed">
            Every space is fully equipped and professionally maintained — ready for you to walk in and create.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {services.map((service) => (
            <Link
              key={service.id}
              to={service.slug}
              className="group block bg-white rounded-2xl overflow-hidden border border-stone-100 hover:border-amber-200 transition-all duration-300 hover:shadow-xl cursor-pointer"
            >
              {/* Image */}
              <div className="relative overflow-hidden h-52">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-stone-900/30 to-transparent" />
                <div className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-xl">
                  <i className={`${service.icon} text-amber-500 text-lg`} />
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="font-serif text-xl font-bold text-stone-900 mb-2 group-hover:text-amber-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-stone-500 text-sm leading-relaxed mb-5">
                  {service.description}
                </p>

                {/* Features */}
                <div className="flex flex-wrap gap-2 mb-5">
                  {service.features.map((feature) => (
                    <span
                      key={feature}
                      className="text-xs bg-stone-100 text-stone-600 px-3 py-1 rounded-full font-medium"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                {/* CTA */}
                <div className="flex items-center gap-1.5 text-amber-600 text-sm font-semibold group-hover:gap-3 transition-all">
                  Explore Studios
                  <i className="ri-arrow-right-line text-base" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
